<template>
  <n-modal @cancel="emit('cancel')">
    <template v-slot:title>
      <p class="modal-card-title">Unable to uninstall app</p>
    </template>

    <template v-slot:body>
      <p>{{ message }}</p>
      <p><br />Please contact support for assistance.</p>
    </template>

    <template v-slot:buttons>
      <n-button @click="$emit('cancel')" variant="primary"> Cancel </n-button>
    </template>
  </n-modal>
</template>

<script lang="ts" setup>
defineProps({
  message: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'cancel'): void;
}>();
</script>
